import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";

import { VERIFY_USER_TEAM } from "../../graphql/mutations";
import { arrInvalid, handleError } from "../../helper";
import { useToastContext } from "../shared/ToastContext";

export default function MemberActionVerify({ open, onClose, ids, onCompleted }) {
    const { setNotify, toggleToast } = useToastContext();

    const [markVerfiy, { loading }] = useMutation(
        VERIFY_USER_TEAM,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Mark verify for Member success",
                    err: false,
                });
                onClose();
                onCompleted && onCompleted();
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;
        setNotify && setNotify({ msg: null, err: false });
        toggleToast && toggleToast(true);

        markVerfiy({
            variables: {
                ids,
            },
        });
    }, [ids, markVerfiy, setNotify, toggleToast]);

    return (
        <Modal
            open={open}
            title="Mark Verify"
            onClose={onClose}
            sectioned
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Verify",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <p>Are you sure to verify for this Member(s)?</p>
        </Modal>
    );
}
